<template>
  <div class="login-page">
    <div class="form-container">
      <el-row>
        <div class="login-header">
          {{ title }}
        </div>
      </el-row>
      <el-row>
        <el-form ref="loginForm" :model="loginValue" :rules="rules">
          <el-form-item prop="username">
            <el-input
              v-model="loginValue.username"
              :placeholder="'用户名' | translateTo(i18nPath)"
              @keyup.native.enter="vmLogin"
              autofocus
            >
              <em slot="prefix" class="el-icon-user"></em>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="loginValue.password"
              :placeholder="'密码' | translateTo(i18nPath)"
              @keyup.native.enter="vmLogin"
            >
              <em slot="prefix" class="el-icon-lock"></em>
            </el-input>
          </el-form-item>
          <!-- <el-checkbox v-model="isRem" style="margin-bottom: 10px" :true-label="1" :false-label="0">
            记住密码
          </el-checkbox> -->
          <el-form-item>
            <el-button type="primary" style="width: 100%" @click="vmLogin" :loading="isloading">
              {{ '登录' | translateTo(i18nPath) }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </div>
  </div>
</template>

<script>
import { setSessionItem, setLocalItem, getLocalItem } from '@/utils/utils';
import ctt from '@/utils/const';
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import { validUserName, validPassword } from './utils';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'login',
  data() {
    return {
      i18nPath: '',
      loginValue: {
        username: '',
        password: ''
      },
      rules: {
        username: { validator: validUserName, trigger: 'blur' },
        password: { validator: validPassword, trigger: 'blur' }
      },
      isloading: false,
      isRem: getLocalItem('isRem') ? parseInt(getLocalItem('isRem')) : 0
    };
  },
  computed: {
    ...mapGetters('app', ['title']),
    redirect() {
      return this.$route.query.redirect;
    }
  },
  methods: {
    ...mapActions('app', ['login']),
    vmLogin() {
      // 登录
      let { username, password } = { ...this.loginValue };
      this.$refs['loginForm'].validate(async valid => {
        if (!valid) return false;
        try {
          this.isloading = true;
          const res = await this.login({ username, password });
          if (this.isRem) {
            const cipherUser = CryptoJS.AES.encrypt(
              this.loginValue.username,
              'username'
            ).toString();
            const cipherPsw = CryptoJS.AES.encrypt(this.loginValue.password, 'password').toString();
            Cookies.set('cipherUser', cipherUser, { expires: 30 });
            Cookies.set('cipherPsw', cipherPsw, { expires: 30 });
          } else {
            Cookies.remove('cipherUser');
            Cookies.remove('cipherPsw');
          }
          setLocalItem('isRem', this.isRem);
          setSessionItem(ctt.ADMIN_TOKEN, res.data);
          this.$router.push(
            '/',
            () => {
              this.isloading = false;
            },
            () => {
              this.isloading = false;
            }
          );
        } catch (err) {
          this.isloading = false;
        }
      });
    }
  },
  async mounted() {
    const favicon = document.getElementsByTagName('link')[0];
    if (favicon.href !== 'static/favicon.ico') {
      favicon.href = 'static/favicon.ico';
    }
    const cipherUser = Cookies.get('cipherUser');
    const cipherPsw = Cookies.get('cipherPsw');
    let autoLogin = false;

    let { username, password } = this.$route.query;

    if (!username || !password) {
      if (cipherUser && cipherPsw) {
        username = CryptoJS.AES.decrypt(cipherUser, 'username').toString(CryptoJS.enc.Utf8);
        password = CryptoJS.AES.decrypt(cipherPsw, 'password').toString(CryptoJS.enc.Utf8);
      }
    } else {
      autoLogin = true;
    }

    this.loginValue.username = username;
    this.loginValue.password = password;

    if (username && password && autoLogin) {
      this.$nextTick(() => {
        this.vmLogin();
      });
    }
  }
};
</script>

<style lang="scss">
.login-page {
  height: 100%;
  position: relative;
  @media screen and (min-width: 481px) {
    background: url('~@/assets/image/login-bg.jpg') no-repeat;
    background-size: cover;
  }
  .form-container {
    width: 320px;
    position: absolute;
    border-radius: 5px;
    padding: 20px;
    background-color: $bg-color;
    right: 10%;
    top: 50%;
    transform: translateY(-50%);
    .login-header {
      font-size: 24px;
      line-height: 26px;
      text-align: center;
      margin: 10px 0 20px 0;
      color: #0ef;
    }
    .el-icon {
      display: inline-block;
      width: 25px;
      text-align: center;
    }
  }
}
</style>
